
import { Component, input, output } from '@angular/core';
import { SortConfig } from '../../../services';

@Component({
  selector: 'app-sortable-header',
  standalone: true,
  imports: [],
  template: `
    <span class="sortable-header" (click)="handleSort()">
      <ng-content></ng-content>
      <i class="fa sort-icon" 
         [class]="getSortIconClass()">
      </i>
    </span>
  `,
  styles: [`
    .sortable-header {
      cursor: pointer;
      user-select: none;
      display: inline-flex;
      align-items: center;
      gap: 5px;
      max-width: 100%;
    }
    
    .sortable-header:hover {
      color: #337ab7;
    }
    
    .sort-icon {
      opacity: 0.5;
      flex-shrink: 0;
    }
    
    .sort-icon.active {
      opacity: 1;
      color: #337ab7;
    }
    
    .fa-sort-up, .fa-sort-down {
      opacity: 1 !important;
      color: #337ab7 !important;
    }
  `]
})
export class SortableHeaderComponent {
  column = input.required<string>();
  sortConfig = input<SortConfig | null>(null);

  sort = output<SortConfig>();

  handleSort(): void {
    const current = this.sortConfig();
    let newDirection: 'asc' | 'desc' = 'asc';

    if (current && current.key === this.column()) {
      newDirection = current.direction === 'asc' ? 'desc' : 'asc';
    }

    this.sort.emit({ key: this.column(), direction: newDirection });
  }

  getSortIconClass(): string {
    const current = this.sortConfig();

    if (!current || current.key !== this.column()) {
      return 'fa-sort';
    }

    return current.direction === 'asc' ? 'fa-sort-up active' : 'fa-sort-down active';
  }
}
